import _sfc_main from "./emojiPC.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "emoji-tool" }, [_c(_setup.SvgIcon, { staticClass: "emoji-icon", attrs: { "icon": _setup.EmojiIcon }, on: { "click": function($event) {
    $event.stopPropagation();
    return _setup.handleEmojiToobar.apply(null, arguments);
  } } }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.showEmojiToolbar, expression: "showEmojiToolbar" }, { name: "click-outside", rawName: "v-click-outside", value: _setup.handleClickOutsideEmojiToobar, expression: "handleClickOutsideEmojiToobar" }], class: _setup.isMobile ? "emoji-list-h5" : "emoji-list" }, _vm._l(_setup.emojiList, function(childrenItem, childrenIndex) {
    return _c("div", { key: childrenIndex, staticClass: "emoji-item", on: { "click": function($event) {
      return _setup.chooseEmoji(childrenItem);
    } } }, [_c("img", { attrs: { "src": _setup.emojiBaseUrl + _setup.emojiMap[childrenItem] } })]);
  }), 0)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "dbb2fbd2"
);
const emojiPC = __component__.exports;
export {
  emojiPC as default
};
